import React, { useState, useEffect, useRef } from 'react';
import {
  Box, Button, TableBody, Card, CardContent,  TableCell, TableContainer, Paper,IconButton,
  TableHead, Grid, Breadcrumbs, CircularProgress, Table, TableRow, Link, Tooltip, Typography, ListItemText, Select, OutlinedInput, MenuItem, TextField, FormControl, InputLabel, Checkbox,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { getRoomMasterdropdata, getShiftMasterdropdata } from '../../../../Api/PropertyMst/Api'
import { useLocation } from "react-router-dom";
import Autocomplete from '@mui/material/Autocomplete';
import { toast } from 'react-toastify';
import { getFormMode } from "../../../../lib/helpers";
import TableComponent from "../../../../atoms/TableComponent/Operations(Bedreports)table";
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { useModulePermissions } from '../../../../GlobalFunction/useModulePermissions';
import dayjs, { Dayjs } from 'dayjs';
import CrudButtons from '../../../../GlobalFunction/CrudButtons'
import axios from 'axios'
import CopyPopup from './copypopup';
import ClearPopup from './Clearpopup';
import {
  Refresh as RefreshIcon,
  ContentCopy as CopyIcon,
  Add as AddIcon,
  Save as SaveIcon,
  Cancel as CancelIcon,
  Delete as DeleteIcon
} from '@mui/icons-material';
import { selectGlobalProperty } from '../../../../redux/propertySlice';
import { useSelector } from 'react-redux';
import { usePermissions } from '../../../../GlobalFunction/userPermissions';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const Form_Mode = getFormMode();
const MenPowerCalender = () => {
  const userId = sessionStorage.getItem('UserId');
  const location = useLocation();
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [dropdownData, setDropdownData] = useState([]);
  const [shiftData, setShiftData] = useState([]);
  const [selectedShifts, setSelectedShifts] = useState([]);
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [monthData, setMonthData] = useState([]);
  const [dates, setDates] = useState([]);
  const [editableCells, setEditableCells] = useState({});
  const [hasChanges, setHasChanges] = useState(false);
  const [modifiedCells, setModifiedCells] = useState({});
  const [activeCellCoords, setActiveCellCoords] = useState(null);
  const [open, setOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const cellRefs = useRef({});
  const [openClear, setOpenClear] = useState(false);
  const [fillAllData, setFillAllData] = useState(null);
  const [summaryData, setSummaryData] = useState(null);
  const Authorization = `eyJhbGciOiJIUzI1NiJ9.eyJWYWxpZElzc3VlciI6IlByYXN5c3QiLCJWYWxpZEF1ZGllbmNlIjoiUHJhc3lzdCJ9.gMMGQ74cWLoymeDv0D4c3UQKTEJSCzdkXoxlW4qF5QU`;
  const [showCancelButton, setShowCancelButton] = useState(true);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleOpenClear = () => setOpenClear(true);
  const handleCloseClear = () => setOpenClear(false);
  const getCurrentPermissions = () => {
    if (location.state?.permissions) {
      localStorage.setItem('userPermissions', JSON.stringify(location.state.permissions));
      return location.state.permissions;
    }
    const storedPermissions = localStorage.getItem('userPermissions');
    return storedPermissions ? JSON.parse(storedPermissions) : [];
  };
  const currentPermissions = getCurrentPermissions();
  const permissions = usePermissions("MPR Calendar");
  const globalProperty = useSelector(selectGlobalProperty);
  const [year, setYear] = useState('');
  const [yearData, setYearData] = useState([]);

  useEffect(() => {
    if (globalProperty && dropdownData?.length > 0) {
      const globalPropertyObj = dropdownData.find(item => item.id == globalProperty);
      if (globalPropertyObj) {
        setSelectedProperty(globalPropertyObj);
      } else if (dropdownData?.length > 0) {
        setSelectedProperty(dropdownData[0]);
      }
    }
  }, [globalProperty, dropdownData]);

  const generateDates = (month, year) => {
    const daysInMonth = new Date(year, month, 0).getDate();
    const dateArray = [];
    for (let i = 1; i <= daysInMonth; i++) {
      dateArray.push(i);
    }
    return dateArray;
  };

  const handlePropertyChange = (event, newValue) => {
    setSelectedProperty(newValue);
  };

  useEffect(() => {
    const currentYear = new Date().getFullYear();
    const years = [
      currentYear - 1,
      currentYear,
      currentYear + 1,
    ];
    setYearData(years);
    setYear(currentYear);
  }, []);

  const handleYearChange = (e, newValue) => {
    setYear(newValue);
  };

  const handleMonthChange = (event, newValue) => {
    if (newValue) {
      setSelectedMonth(newValue);
      const dates = generateDates(newValue.id, dayjs().year());
      setDates(dates);
      setRows([]);
      setEditableCells({});
      setHasChanges(false);
      setModifiedCells({});
      setActiveCellCoords(null);
      setIsEditing(false);
    }
  };

  const handleShiftChange = (event) => {
    const { value } = event.target;
    setSelectedShifts(typeof value === 'string' ? value.split(',') : value);
  };

  const fetchData = async () => {
    if (!selectedProperty) {
      return toast.error("Please select a property");
    }
    if (!selectedMonth) {
      return toast.error("Please select a month");
    }

    try {
      setIsLoading(true);
      const payload = {
        PropId: selectedProperty.id,
        MonthNm: selectedMonth.name.split(" ")[0],
        YearNm: year,                           
        ShiftId: selectedShifts.join(','),
        Flag: 'R'
      };
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}HkTargetCalendar/GetHkTargetCalendar`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${Authorization}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response?.data?.Status === 0) {
        if (!response.data.Data || response.data.Data?.length === 0) {
          setRows([]);
          return;
        }
        const transformedData = transformResponseData(response.data.Data);
        setRows(transformedData || []);
        setEditableCells({});
        setHasChanges(false);
        setModifiedCells({});
        setActiveCellCoords(null);
        // fetchSummaryData();
      } else {
        // toast.error(response?.data?.Message || "Error fetching data");
      }
    } catch (error) {

      setRows([]);
    } finally {
      setIsLoading(false);
    }
  };

  const AddData = async () => {
    if (!selectedProperty) {
      return toast.error("Please select a property");
    }
    if (!selectedMonth) {
      return toast.error("Please select a month");
    }
    if (selectedShifts?.length === 0) {
      return toast.error("Please select at least one shift");
    }

    try {
      setIsLoading(true);
      const payload = {
        PropId: selectedProperty.id,
        MonthNm: selectedMonth.name.split(" ")[0],
        YearNm: year,
        ShiftId: selectedShifts.join(','),
        Flag: 'G'
      };

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}HkTargetCalendar/GetHkTargetCalendar`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${Authorization}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response?.data?.Status === 0) {
        const transformedData = transformResponseData(response.data.Data);
        setRows(transformedData || []);
        setEditableCells({});
        setHasChanges(false);
        setModifiedCells({});
        setActiveCellCoords(null);
        toast.success("Calendar data generated/loaded");
      } else {
        toast.error(response?.data?.Message || "Error fetching data");
      }
    } catch (error) {
      toast.error("Failed to fetch data");
      setRows([]);
    } finally {
      setIsLoading(false);
    }
  };

  const transformResponseData = (apiData) => {
  if (!apiData || apiData?.length === 0) return [];

  const shiftGroups = {};

  apiData.forEach(item => {
    if (!shiftGroups[item.ShiftId]) {
      shiftGroups[item.ShiftId] = {
        ShiftId: item.ShiftId,
        ShiftName: item.ShiftName,
        workTypes: new Map()
      };
    }

    if (!shiftGroups[item.ShiftId].workTypes.has(item.HkWrkTypeId)) {
      shiftGroups[item.ShiftId].workTypes.set(item.HkWrkTypeId, {
        HkWrkTypeId: item.HkWrkTypeId,
        HkWrkTypeName: item.HkWrkTypeName
      });
    }
  });

  const dateGroups = {};
  apiData.forEach(item => {
    const date = new Date(item.TargetDate);
    const day = date.getDate();
    if (!dateGroups[day]) {
      dateGroups[day] = {};
    }
    if (!dateGroups[day][item.ShiftId]) {
      dateGroups[day][item.ShiftId] = {};
    }
    dateGroups[day][item.ShiftId][item.HkWrkTypeId] = item;
  });

  Object.values(shiftGroups).forEach(shift => {
    const workTypesArray = Array.from(shift.workTypes.values());
    shift.data = [];

    workTypesArray.forEach(workType => {
      shift.data.push({
        type: `worktype_${workType.HkWrkTypeId}`,
        label: workType.HkWrkTypeName,
        days: generateDaysArray(dateGroups, shift.ShiftId, workType.HkWrkTypeId, dates?.length),
        targetIds: generateTargetIdsArray(dateGroups, shift.ShiftId, workType.HkWrkTypeId, dates?.length),
        isTotalRow: false,
        workTypeId: workType.HkWrkTypeId
      });
    });

    const totalDaysArray = Array(dates?.length).fill(0);
    shift.data.push({
      type: 'day_total',
      label: 'Day Total',
      days: totalDaysArray,
      targetIds: [],
      isTotalRow: true
    });
    
    const totalDays = dates?.length || 0;
    for (let dayIndex = 0; dayIndex < totalDays; dayIndex++) {
      recalculateDayTotal(shift, dayIndex);
    }
  });

  return Object.values(shiftGroups);
};

  const generateDaysArray = (dateGroups, shiftId, workTypeId, daysCount) => {
    const daysArray = Array(daysCount).fill(0);
    for (let day = 1; day <= daysCount; day++) {
      if (dateGroups[day] &&
        dateGroups[day][shiftId] &&
        dateGroups[day][shiftId][workTypeId]) {
        const value = dateGroups[day][shiftId][workTypeId].TgHkTotal;
        daysArray[day - 1] = value !== null && value !== undefined ? parseFloat(value) : 0;
      }
    }
    return daysArray;
  };

 const generateDayTotalArray = (dateGroups, shiftId, daysCount) => {
  const daysArray = Array(daysCount).fill(0);
  for (let day = 1; day <= daysCount; day++) {
    if (dateGroups[day] && dateGroups[day][shiftId]) {
      let dayTotal = 0;
      Object.values(dateGroups[day][shiftId]).forEach(item => {
        if (item.TgHkTotal !== null && item.TgHkTotal !== undefined) {
          const value = parseFloat(item.TgHkTotal);
          if (!isNaN(value)) {
            dayTotal += value;
          }
        }
      });
      daysArray[day - 1] = dayTotal;
    }
  }
  return daysArray;
};

  const generateTargetIdsArray = (dateGroups, shiftId, workTypeId, daysCount) => {
    const targetIdsArray = Array(daysCount).fill(0);
    for (let day = 1; day <= daysCount; day++) {
      if (dateGroups[day] &&
        dateGroups[day][shiftId] &&
        dateGroups[day][shiftId][workTypeId]) {
        const targetId = dateGroups[day][shiftId][workTypeId].HkTargetId;
        targetIdsArray[day - 1] = targetId !== null ? targetId : 0;
      }
    }
    return targetIdsArray;
  };

  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        const response = await getRoomMasterdropdata({
          Flag: "",
          UserId: userId,
        });
        if (response?.data?.Status === 0) {
          const dropdownItems = response.data.Data.map((item) => ({
            id: item.PropId,
            name: item.Name,
          }));
          setDropdownData(dropdownItems);
          // if (dropdownItems?.length > 0) {
          //   setSelectedProperty(dropdownItems[0]);
          // }
        }
      } catch (error) {
        toast.error("Error fetching property data");
      }
    };

    fetchDropdownData();
  }, [userId]);

  useEffect(() => {
    const fetchShiftData = async () => {
      try {
        const response = await getShiftMasterdropdata();
        if (response?.data?.Status === 0) {
          const dropdownItems = response.data.Data.map((item) => ({
            id: item.ShiftId,
            name: item.ShiftName,
          }));
          setShiftData(dropdownItems);
        }
      } catch (error) {
        toast.error("Error fetching shift data");
      }
    };
    fetchShiftData();
  }, []);

  useEffect(() => {
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1;
    if (monthData?.length > 0) {
      const currentMonthOption = monthData.find(month => month.id === currentMonth);
      if (currentMonthOption) {
        setSelectedMonth(currentMonthOption);
        const dates = generateDates(currentMonth, dayjs().year());
        setDates(dates);
      }
    }
  }, [monthData]);

  useEffect(() => {
    if (shiftData?.length > 0) {
      setSelectedShifts([shiftData[0].id]);
    }
  }, [shiftData]);

  useEffect(() => {
    const fetchMonthData = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}HkTargetCalendar/GetMstMonthDrp`, {},
          {
            headers: {
              Authorization: `Bearer ${Authorization}`,
              "Content-Type": "application/json",
            },
          }
        );
        if (response?.data?.Status === 0) {
          const dropdownItems = response.data.Data.map((item) => ({
            id: item.MonthId,
            name: `${item.MonthName}`
          }));
          dropdownItems.sort((a, b) => a.id - b.id);
          setMonthData(dropdownItems);
        }
      } catch (error) {
        toast.error("Error fetching month data");
      }
    };
    fetchMonthData();
  }, []);

  const handleHomeClick = () => {
    navigate('/dashboard');
  };

  const handleLocationClick = () => {
    navigate('/operations/housekeepin', {
      state: {
        permissions: currentPermissions
      }
    });
  };

  const makeAllCellsEditable = () => {
    const editableMap = {};
    rows.forEach(row => {
      row.data.forEach(dataItem => {
        if (!dataItem.isTotalRow) {
          dataItem.days.forEach((_, dayIndex) => {
            const cellKey = `${row.ShiftId}-${dataItem.type}-${dayIndex}`;
            editableMap[cellKey] = true;
          });
        }
      });
    });
    setEditableCells(editableMap);
  };

  const handleCellClick = (shiftId, dataType, dayIndex, rowIndex, colIndex) => {
  if (dataType === 'day_total') return;

  makeAllCellsEditable();
  const actualRowIndex = getRowIndexFromCoordinates(shiftId, dataType);
  setActiveCellCoords({ 
    shiftId, 
    dataType, 
    dayIndex, 
    rowIndex: actualRowIndex, 
    colIndex 
  });
  setTimeout(() => {
    const cellKey = `${shiftId}-${dataType}-${dayIndex}`;
    if (cellRefs.current[cellKey]) {
      cellRefs.current[cellKey].focus();
      cellRefs.current[cellKey].select();
    }
  }, 50);
  setIsEditing(true);
};

const handleCellChange = (shiftId, dataType, dayIndex, value) => {
  if (dataType === 'day_total') return;

  const newRows = [...rows];
  const shiftIndex = newRows.findIndex(row => row.ShiftId === shiftId);
  if (shiftIndex !== -1) {
    const dataIndex = newRows[shiftIndex].data.findIndex(item => item.type === dataType);
    if (dataIndex !== -1) {
      let numValue;
      if (value === '' || value === null || value === undefined) {
        numValue = 0;
      } else {
        numValue = parseFloat(value);
        if (isNaN(numValue)) {
          numValue = 0;
        }
      }
      newRows[shiftIndex].data[dataIndex].days[dayIndex] = numValue;
      recalculateDayTotal(newRows[shiftIndex], dayIndex);

      setRows(newRows);
      setHasChanges(true);
      const dayNum = dayIndex + 1;
      const targetId = newRows[shiftIndex].data[dataIndex].targetIds[dayIndex];

      setModifiedCells(prev => ({
        ...prev,
        [`${shiftId}-${dataType}-${dayNum}`]: {
          shiftId: shiftId,
          dayIndex: dayNum,
          type: dataType,
          value: numValue,
          targetId: targetId,
          workTypeId: newRows[shiftIndex].data[dataIndex].workTypeId
        }
      }));
      setFillAllData({ 
        shiftId: shiftId,
        dataType, 
        value: numValue,
        workTypeId: newRows[shiftIndex].data[dataIndex].workTypeId 
      });
    }
  }
};

const recalculateDayTotal = (shift, dayIndex) => {
  const totalRowIndex = shift.data.findIndex(item => item.type === 'day_total');
  if (totalRowIndex !== -1) {
    let dayTotal = 0;
    shift.data.forEach(item => {
      if (!item.isTotalRow && item.days[dayIndex] !== undefined && item.days[dayIndex] !== null) {
        const value = parseFloat(item.days[dayIndex]);
        if (!isNaN(value)) {
          dayTotal += value;
        }
      }
    });
    shift.data[totalRowIndex].days[dayIndex] = dayTotal;
  }
};

  const navigateToCell = (direction) => {
  if (!activeCellCoords) return;

  const { shiftId, dataType, dayIndex, rowIndex, colIndex } = activeCellCoords;

  const currentShiftIndex = rows.findIndex(row => row.ShiftId === shiftId);
  if (currentShiftIndex === -1) return;
  
  const currentShift = rows[currentShiftIndex];
  const currentDataIndex = currentShift.data.findIndex(item => item.type === dataType);
  if (currentDataIndex === -1) return;
  
  let newShiftIndex = currentShiftIndex;
  let newDataIndex = currentDataIndex;
  let newDayIndex = dayIndex;
  
  switch (direction) {
    case 'up':
      if (currentDataIndex > 0) {
        newDataIndex = currentDataIndex - 1;
      } else {
        if (currentShiftIndex > 0) {
          newShiftIndex = currentShiftIndex - 1;
          newDataIndex = rows[newShiftIndex].data.length - 1;
        }
      }
      break;
      
    case 'down':
      if (currentDataIndex < currentShift.data.length - 1) {
        newDataIndex = currentDataIndex + 1;
      } else {
        if (currentShiftIndex < rows.length - 1) {
          newShiftIndex = currentShiftIndex + 1;
          newDataIndex = 0;
        }
      }
      break;
      
    case 'left':
      if (dayIndex > 0) {
        newDayIndex = dayIndex - 1;
      }
      break;
      
    case 'right':
      if (dayIndex < dates.length - 1) {
        newDayIndex = dayIndex + 1;
      }
      break;
      
    default:
      break;
  }
  
  if (newShiftIndex !== currentShiftIndex || newDataIndex !== currentDataIndex || newDayIndex !== dayIndex) {
    const targetShift = rows[newShiftIndex];
    const targetData = targetShift.data[newDataIndex];
    if (targetData.isTotalRow) {
      if (direction === 'down' && newDataIndex < targetShift.data.length - 1) {
        newDataIndex = newDataIndex + 1;
        const newTargetData = targetShift.data[newDataIndex];
        if (!newTargetData.isTotalRow) {
          setActiveCellCoords({
            shiftId: targetShift.ShiftId,
            dataType: newTargetData.type,
            dayIndex: newDayIndex,
            rowIndex: getRowIndexFromCoordinates(targetShift.ShiftId, newTargetData.type),
            colIndex: newDayIndex
          });
          focusCell(targetShift.ShiftId, newTargetData.type, newDayIndex);
          return;
        }
      } else if (direction === 'up' && newDataIndex > 0) {
        newDataIndex = newDataIndex - 1;
        const newTargetData = targetShift.data[newDataIndex];
        if (!newTargetData.isTotalRow) {
          setActiveCellCoords({
            shiftId: targetShift.ShiftId,
            dataType: newTargetData.type,
            dayIndex: newDayIndex,
            rowIndex: getRowIndexFromCoordinates(targetShift.ShiftId, newTargetData.type),
            colIndex: newDayIndex
          });
          focusCell(targetShift.ShiftId, newTargetData.type, newDayIndex);
          return;
        }
      }
      return;
    }
    
    const targetRowIndex = getRowIndexFromCoordinates(targetShift.ShiftId, targetData.type);
    
    setActiveCellCoords({
      shiftId: targetShift.ShiftId,
      dataType: targetData.type,
      dayIndex: newDayIndex,
      rowIndex: targetRowIndex,
      colIndex: newDayIndex
    });
    
    focusCell(targetShift.ShiftId, targetData.type, newDayIndex);
  }
};

 const getRowIndexFromCoordinates = (shiftId, dataType) => {
  let rowCounter = 0;
  for (const row of rows) {
    for (const dataItem of row.data) {
      if (row.ShiftId === shiftId && dataItem.type === dataType) {
        return rowCounter;
      }
      rowCounter++;
    }
  }
  return 0;
};
const focusCell = (shiftId, dataType, dayIndex) => {
  setTimeout(() => {
    const cellKey = `${shiftId}-${dataType}-${dayIndex}`;
    if (cellRefs.current[cellKey]) {
      cellRefs.current[cellKey].focus();
      cellRefs.current[cellKey].select();
    }
  }, 50);
};

  const getCellByCoordinates = (rowIndex, colIndex) => {
    let currentRowCount = 0;

    for (const row of rows) {
      for (const dataItem of row.data) {
        if (dataItem.isTotalRow) continue;
        if (currentRowCount === rowIndex) {
          return {
            shiftId: row.ShiftId,
            dataType: dataItem.type,
            dayIndex: colIndex
          };
        }
        currentRowCount++;
      }
    }
    return null;
  };

const handleKeyDown = (e, shiftId, dataType, dayIndex, rowIndex, colIndex) => {
  if (dataType === 'day_total') return;

  switch (e.key) {
    case 'ArrowUp':
      e.preventDefault();
      navigateToCell('up');
      break;
    case 'ArrowDown':
      e.preventDefault();
      navigateToCell('down');
      break;
    case 'ArrowLeft':
      if (e.target.selectionStart !== 0 || e.target.selectionEnd !== 0) {
        return;
      }
      e.preventDefault();
      navigateToCell('left');
      break;
    case 'ArrowRight':
      if (e.target.selectionStart !== e.target.value?.length ||
        e.target.selectionEnd !== e.target.value?.length) {
        return;
      }
      e.preventDefault();
      navigateToCell('right');
      break;
    case 'Tab':
      e.preventDefault();
      navigateToCell(e.shiftKey ? 'left' : 'right');
      break;
    case 'Enter':
      e.preventDefault();
      navigateToCell('down');
      break;
    default:
      break;
  }
};

  const prepareUpdateData = () => {
    if (Object.keys(modifiedCells)?.length === 0) {
      return [];
    }
    const updateData = [];
    const year = dayjs().year();
    const monthId = selectedMonth.id;
    const groupedByDayAndShift = {};

    Object.entries(modifiedCells).forEach(([key, cellData]) => {
      const { shiftId, dayIndex, type, value, targetId, workTypeId } = cellData;
      const dayShiftKey = `${shiftId}-${dayIndex}-${workTypeId}`;
      if (!groupedByDayAndShift[dayShiftKey]) {
        groupedByDayAndShift[dayShiftKey] = {
          shiftId,
          dayIndex,
          workTypeId,
          targetId: targetId || 0,
          value: value
        };
      }
    });

    Object.values(groupedByDayAndShift).forEach(({ shiftId, dayIndex, workTypeId, targetId, value }) => {
      const targetDate = `${year}-${monthId?.toString().padStart(2, '0')}-${dayIndex?.toString().padStart(2, '0')}`;
      const shiftData = rows.find(row => row.ShiftId === shiftId);
      if (shiftData) {
        const payload = {
          "PropId": selectedProperty.id,
          "YearNm": year,
          "MonthNm": selectedMonth.name.split(" ")[0],
          "ShiftId": shiftId,
          "TargetDate": targetDate,
          "Status": "1",
          "HkTargetId": targetId || 0,
          "HkWrkTypeId": workTypeId,
          "TgHkTotal": value || 0
        };

        if (!targetId || targetId === 0) {
          payload.CreatedBy = parseInt(userId || "0");
          payload.UpdatedBy = 0;
        } else {
          payload.CreatedBy = 0;
          payload.UpdatedBy = parseInt(userId || "0");
        }

        updateData.push(payload);
      }
    });

    return updateData;
  };

  const handleUpdate = async () => {
    if (!hasChanges) {
      toast.info("No changes to update");
      return;
    }
    try {
      setIsLoading(true);
      const updateData = prepareUpdateData();
      if (updateData?.length === 0) {
        toast.info("No changes to update");
        setIsLoading(false);
        return;
      }
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}HkTargetCalendar/UpsertTargetCalendar`,
        updateData,
        {
          headers: {
            Authorization: `Bearer ${Authorization}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response?.data?.Status === 0) {
        toast.success(response?.data?.Message || "Data updated successfully");
        setHasChanges(false);
        setModifiedCells({});
        setIsEditing(false);
        // AddData();
        setFillAllData(null);
      } else {
        toast.error(response?.data?.Message || "Error updating data");
      }
    } catch (error) {
      console.error('Error updating data:', error);
      toast.error("Failed to update data");
    } finally {
      setIsLoading(false);
    }
  };

  const handleTableBlur = (e) => {
    if (!e.currentTarget.contains(e.relatedTarget)) {
      setEditableCells({});
      setActiveCellCoords(null);
    }
  };

  const handleCancel = () => {
    setIsEditing(false);
    if (hasChanges) {
      AddData();
    }
    setFillAllData(null);
    toast.info("Operation cancelled");
  };

const handleAutoFillAllRows = () => {
  if (!fillAllData) {
    toast.info("Please edit a cell first to use fill all rows");
    return;
  }

  const { shiftId, dataType, value, workTypeId } = fillAllData;


  const sourceShiftIndex = rows.findIndex(row => row.ShiftId === shiftId);
  if (sourceShiftIndex === -1) return;

  const sourceDataIndex = rows[sourceShiftIndex].data.findIndex(item => item.type === dataType);
  if (sourceDataIndex === -1) return;

  const newRows = [...rows];
  const modifiedCellsUpdates = {};

  const targetShiftIndex = newRows.findIndex(row => row.ShiftId === shiftId);
  
  if (targetShiftIndex !== -1) {
    const targetShift = newRows[targetShiftIndex];
 
    targetShift.data.forEach((dataItem, dataItemIndex) => {
      if (dataItem.isTotalRow) return;

      if (workTypeId && dataItem.workTypeId === workTypeId) {
  
        dataItem.days.forEach((_, dayIndex) => {
          dataItem.days[dayIndex] = value;
          
          const dayNum = dayIndex + 1;
          const targetId = dataItem.targetIds[dayIndex];
          
          const cellKey = `${targetShift.ShiftId}-${dataItem.type}-${dayNum}`;
          modifiedCellsUpdates[cellKey] = {
            shiftId: targetShift.ShiftId,
            dayIndex: dayNum,
            type: dataItem.type,
            value: value,
            targetId: targetId,
            workTypeId: dataItem.workTypeId
          };
        });
      }
    });
    
    // Recalculate day totals for this specific shift only
    const totalDays = targetShift.data[0]?.days?.length || 0;
    for (let dayIndex = 0; dayIndex < totalDays; dayIndex++) {
      recalculateDayTotal(targetShift, dayIndex);
    }
  }

  setRows(newRows);
  setModifiedCells(prev => ({
    ...prev,
    ...modifiedCellsUpdates
  }));
  setHasChanges(true);
  setIsEditing(true);
  
  toast.success(`Filled all rows for ${shiftId} shift with value: ${value}`);
};

  const fetchSummaryData = async () => {
    if (!selectedProperty) {
      return toast.error("Please select a property");
    }
    if (!selectedMonth) {
      return toast.error("Please select a month");
    }

    try {
      const payload = {
        PropId: selectedProperty.id,
        YearNm: 2025,
        MonthNm: selectedMonth.name.split(" ")[0],
        ShiftId: selectedShifts.join(","),
        TargetDate: "",
      };

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}HkTargetCalendar/GetHkTargetCalendarSummary`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${Authorization}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response?.data?.Status === 0) {
        setSummaryData(response.data.Data);
      } else {
        toast.error(response?.data?.Message || "Error fetching summary data");
      }
    } catch (error) {
      toast.error("Failed to fetch summary data");
    }
  };

  const currentDate = new Date();
  const currentDay = currentDate.getDate();
  const currentMonthNum = currentDate.getMonth() + 1;
  const isCurrentMonth = selectedMonth && selectedMonth.id === currentMonthNum;

  return (
    <>
      <Box sx={{ maxWidth: "94vw", overflow: "hidden", padding: 2 }}>
        <Box sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexDirection: { xs: 'column', sm: 'row', md: 'row' },

        }}>
          <Breadcrumbs aria-label="breadcrumb" separator="›">
            <Link underline="hover" color="#635bff" onClick={handleHomeClick} sx={{ cursor: 'pointer' }}>
              Home
            </Link>
            <Link underline="hover" color="#635bff" onClick={handleLocationClick} sx={{ cursor: 'pointer' }}>
              Operations
            </Link>
            <Typography color="text.primary">Men Power Calendar</Typography>
          </Breadcrumbs>
          <IconButton
            onClick={() => navigate('/operations/housekeepin')}
            sx={{
              backgroundColor: '#635bff',
              borderRadius: '50%',
              width: 26,
              height: 26,
              '&:hover': {
                backgroundColor: '#635bff',
              },
              boxShadow: 1,
            }}
          >
            <ArrowBackIcon sx={{ color: 'white' }} />
          </IconButton>
        </Box>
        <Paper sx={{ px: 2, mb: 2, pb: 1 ,mt:1.5}}>
          <Grid container spacing={2} alignItems="center" wrap="nowrap">
            <Grid item xs={12} md={2.5}>
              <Autocomplete
                options={dropdownData}
                getOptionLabel={(option) => option.name}
                value={selectedProperty}
                onChange={handlePropertyChange}
                renderInput={(params) => (
                  <TextField {...params} label="Property" size="small" fullWidth />
                )}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <Autocomplete
                options={yearData}
                getOptionLabel={(option) => `${option}`}
                value={year}
                onChange={handleYearChange}
                renderInput={(params) => (
                  <TextField {...params} label="Year" size="small" fullWidth />
                )}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <Autocomplete
                options={monthData}
                getOptionLabel={(option) => option.name}
                value={selectedMonth}
                onChange={handleMonthChange}
                renderInput={(params) => (
                  <TextField {...params} label="Month" size="small" fullWidth />
                )}
              />
            </Grid>

            <Grid item xs={12} md={2}>
              <FormControl fullWidth size="small">
                <InputLabel id="shift-checkbox-label">Shift</InputLabel>
                <Select
                  labelId="shift-checkbox-label"
                  id="shift-checkbox"
                  multiple
                  value={selectedShifts}
                  onChange={handleShiftChange}
                  input={<OutlinedInput label="Shift" />}
                  renderValue={(selected) => {
                    const selectedNames = shiftData
                      .filter((item) => selected.includes(item.id))
                      .map((item) => item.name);
                    return selectedNames.join(", ");
                  }}
                  MenuProps={{
                    PaperProps: {
                      style: { maxHeight: 234, width: 200 },
                    },
                  }}
                >
                  {shiftData.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      <Checkbox checked={selectedShifts.includes(item.id)} size="small" />
                      <ListItemText primary={item.name} disableTypography />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs="auto">
               <Tooltip title={permissions.ViewRec !=="1" ? "You don't have permission":"Get Calender"} arrow>
                <span>
              <Button
                variant="contained"
                onClick={fetchData}
                startIcon={<RefreshIcon />}
                sx={{
                  height: "40px",
                  backgroundColor: "#635bff",
                  borderRadius: "8px",
                  boxShadow: "0 4px 6px rgba(99, 91, 255, 0.2)",
                  transition: "all 0.2s ease",
                  textTransform: "none",
                  fontWeight: "600",
                  "&:hover": {
                    backgroundColor: "#524bd9",
                    boxShadow: "0 6px 10px rgba(99, 91, 255, 0.3)",
                    transform: "translateY(-2px)"
                  }
                }}
                disabled={isEditing || permissions.ViewRec !=="1"}
              >
                Get Data
              </Button>
              </span>
              </Tooltip>
            </Grid>

            <Grid item xs="auto">
              <Tooltip title={permissions.AddRec !=="1" ? "You don't have permission":"Add Calender"} arrow>
                <span>
              <Button
                variant="contained"
                onClick={AddData}
                startIcon={<AddIcon />}
                sx={{
                  height: "40px",
                  backgroundColor: "#635bff",
                  borderRadius: "8px",
                  boxShadow: "0 4px 6px rgba(99, 91, 255, 0.2)",
                  transition: "all 0.2s ease",
                  textTransform: "none",
                  fontWeight: "600",
                  "&:hover": {
                    backgroundColor: "#524bd9",
                    boxShadow: "0 6px 10px rgba(99, 91, 255, 0.3)",
                    transform: "translateY(-2px)"
                  }
                }}
                disabled={isEditing || permissions.AddRec !=="1"}
              >
                Add
              </Button>
              </span>
              </Tooltip>
            </Grid>

            <Grid item xs="auto">
              <Tooltip title={permissions.EditRec !=="1" ? "You don't have permission":"Update Calender"} arrow>
              <Button
                variant="contained"
                onClick={handleUpdate}
                startIcon={<SaveIcon />}
                sx={{
                  height: "40px",
                  backgroundColor: "#4caf50",
                  borderRadius: "8px",
                  boxShadow: "0 4px 6px rgba(76, 175, 80, 0.2)",
                  transition: "all 0.2s ease",
                  textTransform: "none",
                  fontWeight: "600",
                  "&:hover": {
                    backgroundColor: "#3d9140",
                    boxShadow: "0 6px 10px rgba(76, 175, 80, 0.3)",
                    transform: "translateY(-2px)"
                  }
                }}
                disabled={!isEditing || permissions.EditRec !=="1"}
              >
                Update
              </Button>
              </Tooltip>
            </Grid>

            <Grid item xs="auto">
              <Button
                variant="outlined"
                onClick={handleCancel}
                startIcon={<CancelIcon />}
                sx={{
                  height: "40px",
                  borderRadius: "8px",
                  borderColor: "#f44336",
                  color: "#f44336",
                  transition: "all 0.2s ease",
                  textTransform: "none",
                  fontWeight: "600",
                  "&:hover": {
                    backgroundColor: "rgba(244, 67, 54, 0.04)",
                    borderColor: "#d32f2f",
                    color: "#d32f2f"
                  }
                }}
                disabled={!isEditing}
              >
                Cancel
              </Button>
            </Grid>

            <Grid item xs="auto">
               <Tooltip title={permissions.DeleteRec !=="1" ? "You don't have permission":"Update Calender"} arrow>
                <span>
              <Button
                variant="outlined"
                onClick={handleOpenClear}
                startIcon={<DeleteIcon />}
                sx={{
                  height: "40px",
                  borderRadius: "8px",
                  borderColor: "#f44336",
                  color: "#f44336",
                  transition: "all 0.2s ease",
                  textTransform: "none",
                  fontWeight: "600",
                  "&:hover": {
                    backgroundColor: "rgba(244, 67, 54, 0.04)",
                    borderColor: "#d32f2f",
                    color: "#d32f2f"
                  }
                }}
              disabled={ permissions.DeleteRec !=="1"}
              >
                Delete
              </Button>
              </span>
              </Tooltip>
            </Grid>
          </Grid>
        </Paper>
        {isLoading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
            <CircularProgress />
          </Box>
        ) : (
          <Paper sx={{ width: '100%', overflow: 'hidden' }}>
            {rows?.length > 0 ? (
              <>
                {fillAllData && (
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 1 }}>
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      onClick={handleAutoFillAllRows}
                    >
                      Fill All Rows
                    </Button>
                  </Box>
                )}
                <TableContainer sx={{ maxHeight: 'calc(100vh - 250px)' }}>
                  <Table stickyHeader size="small" aria-label="calendar table">
                    <TableHead>
                      <TableRow>
                        <TableCell
                          sx={{
                            backgroundColor: '#1976d2',
                            color: 'white',
                            fontWeight: 'bold',
                            position: 'sticky',
                            left: 0,
                            zIndex: 3,
                            width: '100px',
                            borderRight: '1px solid #e0e0e0'
                          }}
                        >
                          Shift
                        </TableCell>
                        <TableCell
                          sx={{
                            backgroundColor: '#1976d2',
                            color: 'white',
                            fontWeight: 'bold',
                            position: 'sticky',
                            zIndex: 3,
                            width: '100px',
                            borderRight: '1px solid #e0e0e0'
                          }}
                        >
                          WkrType
                        </TableCell>
                        {dates.map((date) => (
                          <TableCell
                            key={date}
                            align="center"
                            sx={{
                              backgroundColor: isCurrentMonth && date === currentDay ? '#bbdefb' : '#1976d2',
                              color: 'white',
                              fontWeight: 'bold',
                              width: '28px',
                              minWidth: '28px',
                              maxWidth: '28px',
                            }}
                          >
                            {date}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody onBlur={handleTableBlur}>
                      {rows.map((row, rowGroupIndex) => (
                        row.data.map((item, dataIndex) => {
                          const actualRowIndex = rows.slice(0, rowGroupIndex).reduce((sum, r) => sum + r.data?.length, 0) + dataIndex;

                          const isTotalRow = item.isTotalRow;
                          return (
                            <TableRow key={`${row.ShiftId}-${item.type}`} hover
                              sx={isTotalRow ? { backgroundColor: '#ffcdd2', fontWeight: 'bold' } : {}}
                            >
                              {dataIndex === 0 && (
                                <TableCell
                                  rowSpan={row.data?.length}
                                  sx={{
                                    fontWeight: 'bold',
                                    backgroundColor: isTotalRow ? '#e57373' : '#f5f5f5',
                                    position: 'sticky',
                                    left: 0,
                                    zIndex: 2,
                                    width: 'auto',
                                    minWidth: '120px',
                                    maxWidth: '180px',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    borderRight: '1px solid #e0e0e0'
                                  }}
                                >
                                  {row.ShiftName}
                                </TableCell>
                              )}
                              <TableCell
                                sx={{
                                  fontWeight: 'bold',
                                  backgroundColor: isTotalRow ? '#e57373' : '#f5f5f5',
                                  position: 'sticky',
                                  zIndex: 2,
                                  width: 'auto',
                                  minWidth: '100px',
                                  maxWidth: '150px',
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  borderRight: '1px solid #e0e0e0',
                                  padding: '1px',
                                }}
                              >
                                {item.label}
                              </TableCell>

                              {item.days.map((day, dayIndex) => {
                                const cellKey = `${row.ShiftId}-${item.type}-${dayIndex}`;
                                const isEditable = editableCells[cellKey] && !isTotalRow;
                                const cellContent = day?.toString();
                                const contentWidth = Math.max(cellContent?.length * 8, 28);
                                const isCurrentDateCell = isCurrentMonth && (dayIndex + 1) === currentDay;
                                const showZero = day === 0;

                                return (
                                  <TableCell
                                    key={dayIndex}
                                    align="center"
                                    onClick={!isTotalRow ? () => handleCellClick(row.ShiftId, item.type, dayIndex, actualRowIndex, dayIndex) : undefined}
                                    sx={{
                                      p: 0,
                                      width: `${contentWidth}px`,
                                      minWidth: '28px',
                                      maxWidth: '38px',
                                      height: '28px',
                                      backgroundColor: isTotalRow ? '#95949b' : (showZero ? '#f5f5f5' : '#e3f2fd'),
                                      color: isTotalRow ? 'white' : (showZero ? '#757575' : '#0d47a1'),
                                      fontWeight: isTotalRow ? 'bold' : (showZero ? 'normal' : 'bold'),
                                      borderWidth: '1px',
                                      borderStyle: 'solid',
                                      borderColor: activeCellCoords &&
                                        activeCellCoords.shiftId === row.ShiftId &&
                                        activeCellCoords.dataType === item.type &&
                                        activeCellCoords.dayIndex === dayIndex
                                        ? '#2196f3'
                                        : '#e0e0e0',
                                      cursor: isTotalRow ? 'default' : 'pointer',
                                      '&:hover': !isTotalRow ? {
                                        backgroundColor: '#f0f7ff',
                                        borderColor: '#2196f3',
                                        borderWidth: '2px'
                                      } : {},
                                      position: 'relative',
                                      fontSize: '0.75rem'
                                    }}
                                  >
                                    {isEditable ? (
                                      <input
                                        ref={el => cellRefs.current[cellKey] = el}
                                        type="number"
                                        value={cellContent}
                                        onChange={(e) => handleCellChange(row.ShiftId, item.type, dayIndex, e.target.value)}
                                        onKeyDown={(e) => handleKeyDown(e, row.ShiftId, item.type, dayIndex, actualRowIndex, dayIndex)}
                                        onFocus={(e) => {
                                          e.target.select();
                                          setActiveCellCoords({
                                            shiftId: row.ShiftId,
                                            dataType: item.type,
                                            dayIndex: dayIndex,
                                            rowIndex: actualRowIndex,
                                            colIndex: dayIndex
                                          });
                                        }}
                                        autoFocus={activeCellCoords &&
                                          activeCellCoords.shiftId === row.ShiftId &&
                                          activeCellCoords.dataType === item.type &&
                                          activeCellCoords.dayIndex === dayIndex}
                                        style={{
                                          width: '100%',
                                          height: '100%',
                                          textAlign: 'center',
                                          border: 'none',
                                          padding: '0',
                                          backgroundColor: 'transparent',
                                          fontSize: '0.75rem',
                                          fontWeight: 'inherit',
                                          color: 'inherit',
                                          outline: 'none',
                                          boxSizing: 'border-box'
                                        }}
                                      />
                                    ) : (
                                      day
                                    )}
                                  </TableCell>
                                );
                              })}
                            </TableRow>
                          );
                        })
                      ))}
                    </TableBody>
                  </Table>

                </TableContainer>


              </>
            ) : (
              <Box sx={{ p: 4, textAlign: 'center' }}>
                <Typography variant="body1" color="text.secondary">
                  No Record Found.
                </Typography>
              </Box>
            )}
          </Paper>
        )}

        <ToastContainer position="top-right" autoClose={3000} />
      </Box>
      <Box sx={{ display: "flex", mx: 9, mb: 2, gap: 2, alignItems: "center" }}>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Box sx={{ width: 16, height: 16, backgroundColor: "#f5f5f5", borderRadius: "4px" }}></Box>
          <Typography variant="body2">Zero Value</Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Box sx={{ width: 16, height: 16, backgroundColor: "#95949b", borderRadius: "4px" }}></Box>
          <Typography variant="body2">Day total</Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Box sx={{ width: 16, height: 16, backgroundColor: "#e3f2fd", borderRadius: "4px" }}></Box>
          <Typography variant="body2">Available Record</Typography>
        </Box>
      </Box>
      <CopyPopup open={open}
        onClose={handleClose}
        monthData={monthData}
        shiftData={shiftData}
        Authorization={Authorization}
        propId={selectedProperty?.id}
        YearNm={dayjs().year()}
        MonthNm={selectedMonth?.name.split(" ")[0]}
        shiftId={selectedShifts}
      />
      {/* <ClearPopup open={openClear}
        onClose={handleCloseClear}
        monthData={monthData}
        shiftData={shiftData}
        Authorization={Authorization}
        propId={selectedProperty?.id}
        YearNm={dayjs().year()}
        MonthNm={selectedMonth?.name.split(" ")[0]}
        shiftId={selectedShifts}
        fetchData={fetchData}
      /> */}
      <ClearPopup 
  open={openClear}
  onClose={handleCloseClear}
  monthData={monthData}
  shiftData={shiftData}
  Authorization={Authorization}
  propId={selectedProperty?.id}
  YearNm={year} 
  MonthNm={selectedMonth?.name.split(" ")[0]}
  shiftId={selectedShifts}
  fetchData={fetchData}
  selectedMonthProp={selectedMonth}  
  selectedShiftsProp={selectedShifts} 
/>
    </>
  );
};
export default MenPowerCalender